<template>
  <div>
    <div style="overflow-y: scroll; max-height: 275px" class="table-responsive">
      <!-------------------- Tabla de REsultados -------------------->

      <table class="table table-hover">
        <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr @click="seleccionarReq(det)" v-for="det in dataTabla" v-bind:key="det.id">
            <td>
              <div class="value">
                <small
                  ><div class="value">{{ det.producto.sku }}</div></small
                >
                <small class="font-weight-bold">{{ det.producto.nombre }}</small>
              </div>
              <small class="sub-value font-weight-bold" style="color: blue">
                Solicitada: {{ det.cantidad }}
              </small>
            </td>
            <td style="width: 100px">
              <span class="sub-value">
                <small> {{ det.fecha_creacion | moment("DD/MM/YYYY") }}</small>
              </span>
              <br />
              <small class="sub-value font-weight-bold" style="color: blue">
                Abierta: {{ det.cantidad_abierta }}
              </small>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: ["dataTabla", "current"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      currentDet: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    seleccionarReq(detalle) {
      let self = this;
      self.$emit("setDataCurrent", detalle);
    },
  },
};
</script>
